import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'Startseite',
    component: () => import('../components/ContentSites/HomePage.vue'),
  },
  {
    path: '/technologien',
    name: 'Technologien',
    component: () => import('../components/ContentSites/TechnologyPage.vue'),
  },
  {
    path: '/werkstoffe',
    name: 'Werkstoffübersicht',
    component: () => import('../components/ContentSites/MaterialsPage.vue'),
  },
  {
    path: '/nachbearbeitung',
    name: 'Nachbearbeitung',
    component: () => import('../components/ContentSites/PostProcessing.vue'),
  },
  {
    path: '/unternehmen',
    name: 'Unternehmen',
    component: () => import('../components/ContentSites/CompanyPage.vue'),
  },
  {
    path: '/werkstoffe/pa12',
    name: 'PA12',
    component: () => import('../components/Materials/pa12.vue'),
  },
  {
    path: '/werkstoffe/pla',
    name: 'PLA',
    component: () => import('../components/Materials/pla.vue'),
  },
  {
    path: '/werkstoffe/petg',
    name: 'PETG',
    component: () => import('../components/Materials/petg.vue'),
  },
  {
    path: '/werkstoffe/abs',
    name: 'ABS',
    component: () => import('../components/Materials/abs.vue'),
  },
  {
    path: '/werkstoffe/asa',
    name: 'ASA',
    component: () => import('../components/Materials/asa.vue'),
  },
  {
    path: '/werkstoffe/asa-cf',
    name: 'ASA CF',
    component: () => import('../components/Materials/asaCf.vue'),
  },
  {
    path: '/werkstoffe/standard-resin',
    name: 'Standard Resin',
    component: () => import('../components/Materials/standardResin.vue'),
  },

  {
    path: '/impressum',
    name: 'Impressum',
    component: () => import('../components/FooterSites/LegalNotice.vue'),
  },
  {
    path: '/datenschutz',
    name: 'Datenschutz',
    component: () => import('../components/FooterSites/DataPrivacy.vue'),
  },
  {
    path: '/agb',
    name: 'AGB',
    component: () => import('../components/FooterSites/AGB.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        top: 142,
        behavior: 'smooth',
      }
    } else {
      return { top: 0 }
    }
  },
})

export default router
